<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title"><span class="title">User Report</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/userreports/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <form><input type="search" value="" placeholder="Searching..." class="form-control"></form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>



<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/UserReports/MenuList.vue";
import lang from "@/views/modules/UserReports/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/UserReports/ListView.vue";

export default {
name: "new-users",
components: {
    breadcrumbs,
    GenericList,
    CustomList,
    },
    data(){
        return{
            generic: false,
            metaList:[
                {
                    label:'User Name',
                    link:false,
                    moduleName:'UserRole',/// moduleName is required
                    routePath:'users'/// routePath is required at start of object
                },
                {
                    label:'User Email',
                    link:true,
                    routePath:'users'/// routePath is required at start of object
                },
                {
                    label:'User Status',
                    link:false,
                    routePath:''
                },
                {
                    label:'User Role',
                    link:false,
                    routePath:''
                },
            ],
            columns: ['username', 'email', 'status', 'user_role'],

        }
    },
    mounted() {
        this.childMethod();
        this.$emit('MetaView','Awesome')
    },
    methods:{

        childMethod(search=''){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.columns,search);
            }
        },
        openAction() {
            this.isActive = !this.isActive;
        }, 
    }
}

</script>



